module.exports = __webpack_public_path__ + "img/partners.31a166cf.svg";